var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-order-wrap"},[_c('img',{staticClass:"view-img",attrs:{"src":require("@/assets/img/view-order-img.png")}})])
}]

export { render, staticRenderFns }